module.exports = __webpack_public_path__ + "static/img/img-educator-why-2@3x.2f2ffd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-why-2@3x.png
// module id = vDVq
// module chunks = 18